import { render, staticRenderFns } from "./GlideCarousel.vue?vue&type=template&id=50a4a61d&"
import script from "./GlideCarousel.vue?vue&type=script&lang=js&"
export * from "./GlideCarousel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports